"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCrossStorageSync;

var _react = require("react");

var _crossStorage = require("cross-storage");

function useCrossStorageSync(stateData, setStateData, settings) {
  const {
    crossStorageUrl,
    storageKey
  } = settings;
  const [connected, setConnected] = (0, _react.useState)(false);
  const [inSync, setInSync] = (0, _react.useState)(false); // start CrossStorageClient

  const crossStorage = (0, _react.useMemo)(() => {
    if (typeof window === "undefined") return;
    return typeof crossStorageUrl === "string" && crossStorageUrl ? new _crossStorage.CrossStorageClient(crossStorageUrl) : null;
  }, [crossStorageUrl]); // connect client

  (0, _react.useEffect)(() => {
    if (!crossStorage) return;
    crossStorage.onConnect().then(() => setConnected(true));
    return () => crossStorage.close();
  }, [crossStorage, storageKey]); // crossStorage -> state (only once after connection)

  (0, _react.useEffect)(() => {
    if (!crossStorage || !connected) return; // window.crossStorage = crossStorage;

    crossStorage.get(storageKey).then(JSON.parse).then(crossStorageData => {
      if (!crossStorageData || typeof crossStorageData !== "object") return;
      setStateData(tmpState => mergeStates(tmpState, crossStorageData));
      setInSync(true);
    });
  }, [setStateData, connected, crossStorage, storageKey]); // state -> crossStorage

  (0, _react.useEffect)(() => {
    if (!crossStorage || !inSync) return;
    crossStorage.set(storageKey, JSON.stringify(stateData));
  }, [stateData, storageKey, crossStorage, inSync]);
}

function mergeStates() {
  let tmpState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let crossStorageData = arguments.length > 1 ? arguments[1] : undefined;
  const csData = crossStorageData || {};
  const csReadContents = csData.readContents || {};
  let mergedReadContents = { ...csReadContents
  };
  Object.keys(tmpState.readContents).forEach(contentType => {
    mergedReadContents[contentType] = (mergedReadContents[contentType] || 0) + (tmpState.readContents[contentType] || 0);
  });
  return {
    readingTime: (tmpState.readingTime || 0) + (csData.readingTime || 0),
    readContents: mergedReadContents
  };
}